import React, {useEffect, useState} from "react";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import AppBar from "./AppBar";
import ImagePreview from "./ImagePreview";
import ToolbarContainer from "./ToolbarContainer";
import ActionsContainer from "./ActionsContainer";
import {Box} from "@material-ui/core";
import ToolbarContent from "./ToolbarContent";
import {Trans, useTranslation} from "react-i18next";
import {ToolbarOption, ToolbarOptions} from "./ToolBarOptions";


const useStyles = makeStyles(theme => ({
  mainContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  container: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: 'white',
    height: '148px',
    zIndex: '2'
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  formatButtonList: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    marginBottom: theme.spacing(2),
    width: '100%',
    overflow: 'auto',
    '& > li': {
      marginLeft: theme.spacing(1),
      textAlign: 'center',
    }
  },
  formatButton: {
    height: '60px',
    width: '84px',
    backgroundColor: 'black',
    color: 'white',
    padding: 0,
    borderRadius: 0,
    lineHeight: '1em',
    border: '2px solid black',
    '&:active, &:focus, &:hover': {
      backgroundColor: 'black',
      color: 'white'
    }
  },
  selectedFormat: {
    backgroundColor: '#BFDFEC',
    color: 'black',
    '&:active, &:focus, &:hover': {
      backgroundColor: '#BFDFEC',
      color: 'black',
    }
  },
  formatFeatures: {
    fontSize: '0.8em',
    textTransform: 'none',
    fontWeight: 'normal',
    whiteSpace: 'break-spaces'
  }
}));

const ChangeFormat = ({setFormat, onCancel, orderLine}) => {
  const classes = useStyles();
  const { getPrintFormats } = usePriceList();
  const [t] = useTranslation();
  const [cropRect, setCropRect] = useState(orderLine.image.cropRect);
  const [localFormat, setLocalFormat] = useState(() => {
    return orderLine.product;
  })

  useEffect(() => {

  }, [orderLine]);

  const handleSetFormat = (format) => {
      // Lots of code to keep white border if it's set:
    /*
      const oldProduct = getProductByUuid(orderLine.product.uuid);
      const wasWhiteBorderFormat = isWhiteBorderProduct(oldProduct);
      if (wasWhiteBorderFormat) {
        const whiteBorderFormat = getWhiteBorderAlternativeProduct(format);
        if (whiteBorderFormat) {
          format = whiteBorderFormat;
        }
      }

     */
      // Reset crop on change format:
      setCropRect(null);
      setLocalFormat(format);
  }

  const handleSave = () => {
    // If we didn't change the format, keep the crop:
    if (localFormat.uuid == orderLine.product.uuid) {
      onCancel ();
    }
    else {
      setFormat(localFormat, true);
    }
  }
  console.log('Print formats', getPrintFormats());

  return <div className={classes.mainContainer}>
    <AppBar onCancel={onCancel} />

    <ImagePreview orderLine={orderLine} overrideProduct={localFormat} overrideCropRect={cropRect}/>

    <ToolbarContainer>
      <ToolbarContent>
        <ToolbarOptions header={t('Format')}>
          {getPrintFormats().map(format => {
            let nameParts = format.name.match(/^(\d+x\d+)[\s]{0,1}(.*)$/);
            if (!nameParts) {
              nameParts = ['', format.name];
            }

            const isSelected = (format.uuid == localFormat.uuid);

            const content = <>
              <div className='format-name'>{nameParts[1]}</div>
              {nameParts.length > 2 && <div className={classes.formatFeatures}>{nameParts[2]}</div>}
            </>

            return <ToolbarOption key={format}
                                  content={content}
                                  onClick={() => handleSetFormat(format)}
                                  selected={isSelected} />
          })}
        </ToolbarOptions>
      </ToolbarContent>
      <ActionsContainer>
        <Button color="primary" onClick={onCancel}><Trans>Cancel</Trans></Button>
        <Button color="primary" onClick={handleSave}><Trans>Done</Trans></Button>
      </ActionsContainer>
    </ToolbarContainer>
  </div>
}

export default ChangeFormat;